import { Editor } from "@tiptap/react";
import { Link } from "@tiptap/extension-link";

export const TOCLink = Link.extend({
  name: "tocMark",
  openOnClick: false,
  target: null,
  rel: "",
});

export function getTableOfContents(editor: Editor) {
  const tocItems: Record<string, any>[] = []; // Define the type of TOC items more specifically if possible

  editor.state.doc.forEach((node) => {
    if (!node.type || node.type.name !== "heading") return;
    else {
      const level = node.attrs?.level || 1;
      tocItems.push({
        type: "listItem",
        attrs: {
          class: "toc-list",
        },
        content: [
          {
            type: "paragraph",
            content: [
              {
                type: "text",
                text: node.textContent,
                marks: [
                  {
                    type: "tocMark",
                    attrs: {
                      href: node.attrs?.["data-toc-id"] || "#",
                      class: `toc-item toc-level-${level}`,
                      target: null,
                      rel: "",
                    },
                  },
                ],
              },
            ],
          },
        ],
      });
    }
  });

  return tocItems.length
    ? {
        type: "bulletList", // List to contain all TOC items
        attrs: { class: "toc-list" },
        content: tocItems, // All TOC list items
      }
    : {};
}
